import React from 'react';
import UnavailablePage from './UnavailablePage';
export default function Mentees() {
  return <UnavailablePage title="Your Mentees" description="Shared mentoring relationships and mentee profiles are not connected yet." />;
}
